export default "__VITE_ASSET__7FmmGdN1__"